/*
 *   File : ipv.js
 *   Author URI : https://evoqins.com
 *   Description :  In-person verification and video need to be implemented for customers who are not compliant with KYC
 *   Integrations : null
 *   Version : v1.1
 */
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import parse from 'html-react-parser';
import { Tooltip } from 'react-tooltip';
import Cookies from 'js-cookie';

import { GradientButton } from "../../../Component/CTA";
import Icon from '../../../Component/Icon/icon';

import { _getKycProfile } from '../../../Helper/api';
import { useNavigate } from 'react-router-dom';
import { InvestmentHeader } from '../../../Component/Header';
import Breadcrumb from '../../../Component/BreadCrumb/breadcrumb';
import { CustomFilePicker, FilePreview, RadioGroup } from '../../../Component/Form-elements';
import { _uploadDocumentToS3 } from '../../../Service/aws-service';
import { _convertToLabelIdArray, _isFileTypeAllowed } from '../../../Helper';
import APIService from '../../../Service/api-service';
import { CustomLoader } from '../../../Component/Other';
import Store from '../../../Store';

const PAGE_NAVIGATION = [
    { page: 'Home', url: '/' },
    { page: 'Account opening', url: null },
];


const RepushKyc = (props) => {
    const navigate = useNavigate();
    const GENERAL_DATA = useSelector(state => state.generalData.KYC_GENERAL_DATA);
    const PERSONAL_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA.additional_info);
    const [signProof, setSignProof] = useState(null);
    const [signProofError, setSignProofError] = useState("");
    const [signProofUrl, setSignProofUrl] = useState("");
    const [annualIncomeData, setAnnualIncomeData] = useState([]);
    const [selectedAnnualIncome, setSelectedAnnualIncome] = useState(null);
    const [loader, setLoader] = useState(true);

    const [fileLoader, setFileLoader] = useState(false);


    useEffect(() => {
        _getKycGeneralData();
    }, [])

    useEffect(() => {
        if (Object.keys(GENERAL_DATA).length !== 0 && loader === false) {
            let annual_income = _convertToLabelIdArray(GENERAL_DATA?.income_slab);
            setAnnualIncomeData(annual_income);
            if (PERSONAL_DATA?.income !== null) {
                setSelectedAnnualIncome(PERSONAL_DATA?.income)
            }
            else {
                setSelectedAnnualIncome(annual_income[0]?.id)
            }
        }

    }, [GENERAL_DATA, PERSONAL_DATA, loader])

    const _handleSignProof = (path, file) => {
        let file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    setSignProofError("");
                    setFileLoader(5);
                    let url = "general/file-upload";
                    let body = {
                        "key": `support/${file_formatted}`
                    }

                    APIService(true, url, body).then((response) => {
                        if (response.status_code === 200) {
                            setFileLoader(5);

                            // s3 helper
                            _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                setSignProofUrl(response.data.view_info); // file got uploaded successfully
                                setSignProof(file_formatted);

                                setFileLoader(false);
                            }).catch(error => {
                                toast.dismiss();
                                toast.error(error, {
                                    type: "error",
                                });
                                setFileLoader(false);
                            });

                        } else {
                            setFileLoader(false);
                            toast.dismiss();
                            toast.error(response, {
                                type: "error",
                            });
                        }
                    })
                } else {
                    setSignProofError("File size should be less than 5mb");
                }
            }
            else {
                setSignProofError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }

    function _getKycGeneralData() {
        let url = 'kyc/general-data';
        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'KYC_CATEGORIES',
                    payload: response.data
                });
                setLoader(false)
            }
        })
    }

    function _handleProceed(){
        let is_valid = true;
        if (signProofUrl.length === 0) {
            setSignProofError("File is required");
            is_valid = false
        } 
        if(is_valid === true){
            setSignProofUrl("");
            setSignProofError("");
            setSignProof(null);
            toast.dismiss();
            toast.success("KYC Resubmitted successfully");
        }
    }
    return (
        loader === true ?
            <CustomLoader />
            :
            <div className="e-kyc e-page-container margin-72px-bottom">
                {/* Header */}
                <InvestmentHeader />
                {/* Breadcrumb */}
                <Breadcrumb data={PAGE_NAVIGATION} />
                <div className="row pb-sm-0 pb-4 margin-40px-top">
                    <div className="col-sm-8 order-sm-1 order-2 mt-sm-0 mt-3 mb-sm-0 mb-3">
                        <p className="color-black e-poppins e-poppins-bold e-font-24-sm-18 mb-2 position-relative w-max-content">
                            KYC resubmission
                        </p>
                        <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-24px mb-0 pe-5">
                            Some of the details/documents you provided were incorrect or invalid. Please review the rejected fields below, update them, and re-submit your KYC.
                        </p>

                    </div>
                </div>

                <div className="row align-items-center">
                    <div className='col-sm-8'>
                        <p className="color-black e-poppins-medium e-font-18-sm-16 mb-2 pb-1 margin-32px-top position-relative w-max-content">
                            Upload digital signature
                        </p>
                        <div className="border-radius-8px bg-beige p-3">
                            <p className="color-outer-space e-poppins-regular e-font-16-sm-12 line-height-24px mb-0">*Sign on a blank white paper using blue ink, take a clear photo of it and upload</p>
                        </div>
                        <div className='row align-items-center'>
                            <div className="col-sm-6 pt-4 pb-2">
                                <CustomFilePicker accept=".png, .pdf, .jpeg "
                                    className="e-select-file"
                                    error={signProofError}
                                    loading={fileLoader === 5 ? true : false}
                                    onSelectFile={(path, file) => {
                                        _handleSignProof(path, file);
                                    }} />
                                {
                                    signProof === null ?
                                        null
                                        :
                                        <div className="col-12 pt-3">
                                            <FilePreview fileName={signProof}
                                                removeFile={() => {
                                                    setSignProof(null);
                                                    setSignProofUrl("");
                                                }} />
                                        </div>
                                }
                            </div>
                            <div className='col-sm-2 pt-3 pb-2'>
                                <Icon icon="info"
                                    size={24}
                                    className="ms-2"
                                    data-tooltip-id="sign-tooltip" />
                                <Tooltip id="sign-tooltip"
                                    arrowColor='transparent'
                                    effect="float"
                                    place="top"
                                    className='e-tooltip-general'>
                                    Why we require signature
                                </Tooltip>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-4 ">
                        <div className="bg-very-light-gray-md border-radius-16px p-3">
                            <h6 className="color-black e-poppins-medium e-font-14-sm-12 mb-3">*Note</h6>
                            <div className="d-flex gap-1 color-outer-space e-poppins-regular e-font-12">
                                <span>
                                    <Icon icon="cancelled" size={20} />
                                </span>
                                <p className="line-height-20px margin-block-end-0">
                                    The signature you uploaded does not match your PAN records.
                                </p>
                            </div>
                            <div className="d-flex color-outer-space e-poppins-medium e-font-12 margin-block-end-0 mt-2 ms-2">
                                <p className="margin-block-end-0"> </p>
                                <p className="line-height-20px margin-block-end-0">
                                    Please re-upload a clear signature
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center margin-40px-top">
                    <div className='col-sm-8'>
                        <p className="color-black e-poppins-medium e-font-18-sm-16 ">Your annual income</p>
                        <RadioGroup data={annualIncomeData}
                            className={`gap-16px mt-3`}
                            type={2}
                            id={selectedAnnualIncome}
                            radioHandler={(id) => setSelectedAnnualIncome(id)} />
                    </div>
                    <div className="col-sm-4">
                        <div className="bg-very-light-gray-md border-radius-16px p-3">
                            <h6 className="color-black e-poppins-medium e-font-14-sm-12 mb-3">*Note</h6>
                            <div className="d-flex gap-1 color-outer-space e-poppins-regular e-font-12">
                                <span>
                                    <Icon icon="cancelled" size={20} />
                                </span>
                                <p className="line-height-20px margin-block-end-0">
                                    The income range you selected does not match the details provided.
                                </p>
                            </div>
                            <div className="d-flex color-outer-space e-poppins-medium e-font-12 margin-block-end-0 mt-2 ms-2">
                                <p className="margin-block-end-0"> </p>
                                <p className="line-height-20px margin-block-end-0">
                                    Please update with the correct annual income bracket.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <GradientButton label="Re-submit application"
                    className="mt-5 padding-12px-tb px-4 e-font-16"
              handleClick={_handleProceed}  />
            </div>
    )
}

export default RepushKyc;